import { useState } from "react";
import { __FechaFormat } from "./../../Core/environment";
import { format } from "date-fns";
import procedimientos from "./../../Core/procedimientos";

export const useCalcularProductos = (productos, productosCotizacion = []) => {
  const { CalcularProductos, CalcularProducto } = procedimientos.prototype;

  const [productosCalculados, setProductosCalculados] = useState(() => {
    return CalcularProductos(productos, productosCotizacion);
  });

  const setProductos = (productos, productosCotizacion = []) => {
    const productosCalc = CalcularProductos(productos, productosCotizacion);
    setProductosCalculados(productosCalc);
  };

  const setProducto = (productos, posicion, cantidad) => {
    const productosCalc = CalcularProducto(productos, posicion, cantidad);
    setProductosCalculados(productosCalc);
  };

  return [productosCalculados, setProductos, setProducto];
};

export const useCalcularTotal = (productos) => {
  const { CalcularTotal } = procedimientos.prototype;

  const [productosTotal, setProductosTotal] = useState(() => {
    return CalcularTotal(productos);
  });

  const setProductos = (productos) => {
    const productosTotal = CalcularTotal(productos);
    setProductosTotal(productosTotal);
  };

  return [productosTotal, setProductos];
};

export const useAcumuladorCantidad = (productos) => {
  const [cantidadAcumulado, setCantidadAcumulado] = useState(() => {
    return productos.reduce(
      (sum, value) => sum + Number.parseInt(value.Cantidad),
      0
    );
  });

  const setCantidad = (productos) => {
    const cantidadTotal = productos.reduce(
      (sum, value) => sum + Number.parseInt(value.Cantidad),
      0
    );
    setCantidadAcumulado(cantidadTotal);
  };

  return [cantidadAcumulado, setCantidad];
};

export const useAcumuladorTotal = (productos) => {
  const { FormatearPrecio } = procedimientos.prototype;

  const [totalAcumulado, setTotalAcumulado] = useState(() => {
    let total = productos.reduce(
      (sum, value) =>
        sum + Number.parseInt(value.Cantidad) * Number.parseFloat(value.Precio),
      0
    );
    total = FormatearPrecio(total);
    return total;
  });

  const setTotal = (productos) => {
    let total = productos.reduce(
      (sum, value) =>
        sum + Number.parseInt(value.Cantidad) * Number.parseFloat(value.Precio),
      0
    );
    total = FormatearPrecio(total);

    setTotalAcumulado(total);
  };

  return [totalAcumulado, setTotal];
};

export const useMarcadores = (sucursales) => {
  const [marcadores, setMarcadores] = useState(() => {
    const marcadores = sucursales.map((sucursal) => {
      const {
        datos: { Ubicacion, Descripcion },
      } = sucursal;
      const { __: Longitud, l_: Latitud } = Ubicacion;
      return {
        Descripcion,
        lat: Latitud,
        lng: Longitud,
      };
    });

    return marcadores;
  });

  const setSucursales = (sucursales) => {
    const marcadores = sucursales.map((sucursal) => {
      const {
        datos: { Ubicacion, Descripcion },
      } = sucursal;
      const { __: Longitud, l_: Latitud } = Ubicacion;
      return {
        Descripcion,
        lat: Latitud,
        lng: Longitud,
      };
    });
    setMarcadores(marcadores);
  };

  return [marcadores, setSucursales];
};

export const useRangoFechas = () => {
  const [fechas, setFechas] = useState(() => {
    let fechaIni = new Date();
    fechaIni.setMonth(fechaIni.getMonth(), -2);
    const fechas = [
      {
        startDate: fechaIni,
        endDate: new Date(),
        key: "selection",
      },
    ];
    return fechas;
  });

  const setFecha = (fechas) => {
    setFechas(fechas);
  };

  return [fechas, setFecha];
};

export const useFormatearCotizaciones = (cotizaciones) => {
  const [cotizacionesF, setCotizacionesF] = useState(cotizaciones);

  const setDatos = (cotizaciones) => {
    const { FormatearPrecio } = procedimientos.prototype;

    const cotizacionesFormateadas = cotizaciones.map((cotizacion) => {
      const { datos } = cotizacion;
      const { Fecha_Creacion, Productos } = datos;

      const FechaCreacionF = format(Fecha_Creacion.toDate(), __FechaFormat);

      const Cantidad = Productos.map((producto) => {
        const { Cantidad } = producto;
        return Cantidad;
      }).reduce((acumulador, Cantidad) => {
        return (acumulador += Cantidad);
      });

      const Total = Productos.map((producto) => {
        const { Cantidad, Precio } = producto;
        return Cantidad * Precio;
      }).reduce((acumulador, Total) => {
        return (acumulador += Total);
      });

      return {
        ...cotizacion,
        datos: {
          ...datos,
          Fecha_Creacion: FechaCreacionF,
          Cantidad,
          Total: FormatearPrecio(Total),
        },
      };
    });
    setCotizacionesF(cotizacionesFormateadas);
  };

  return [cotizacionesF, setDatos];
};
